import React from 'react';
import {
  Box,
  Typography,
  Paper,
  CircularProgress,
  Alert
} from '@mui/material';

const JsonDataViewer = ({
  title,
  data,
  loading,
  error
}) => {
  return (
    <Paper
      elevation={1}
      sx={{
        p: 2,
        mt: 2,
        overflow: 'auto',
        maxHeight: '70vh'
      }}
    >
      <Typography variant="h6" gutterBottom>{title}</Typography>

      {loading ? (
        <Box display="flex" justifyContent="center" py={4}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Alert severity="error">{error}</Alert>
      ) : (
        <Box
          component="pre"
          sx={{
            p: 2,
            bgcolor: '#f5f5f5',
            borderRadius: 1,
            overflow: 'auto',
            fontSize: '0.875rem',
            border: '1px solid #e0e0e0'
          }}
        >
          {JSON.stringify(data, null, 2)}
        </Box>
      )}
    </Paper>
  );
};

export default JsonDataViewer;
